import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import axios from "axios";
import url from "../../function/url";  // Make sure this URL is correct for your Django backend
import Cookies from "js-cookie";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";

function ManagerSuggestion() {
  const ID = Cookies.get("log_id");
  const user = Cookies.get("User");
  const [Unemployed, setUnemployed] = useState([]);
  const [telecallers, setTelecallers] = useState([]);
  const [selectedUnemployed, setSelectedUnemployed] = useState(null);
  const [telecaller, setTelecaller] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);

  // Fetch unemployed and telecallers data
  useEffect(() => {
    axios.get(`${url.path}/unemployed_details/?id=${ID}`)
    .then((res) => {
        console.log("API Response:", res.data); // Debugging step
        if (res.data && res.data.unemployed_details) {
          setUnemployed(res.data.unemployed_details); // Make sure unemployed_details is set
          setTelecallers(res.data.telecallers || []); // Default to an empty array if telecallers is missing
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
  }, []);

  const itemsPerPage = 3;

  // Filter Unemployed data based on searchTerm
  const filteredData = Unemployed.filter((item) =>
    item.Candidate_Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const offset = currentPage * itemsPerPage;
  const currentItems = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleOpenModal = (cmp) => {
    setSelectedUnemployed(cmp);
  };

  const handleCloseModal = () => {
    setSelectedUnemployed(null);
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  function handleSubmit(e) {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append("id", ID);
    formdata.append("unemployed", selectedUnemployed.id);
    formdata.append("telecaller", telecaller);

    axios
      .post(`${url.path}/assign_unemployed/`, formdata)
      .then((res) => {
        if (res.data.status) {
          Toast.fire({
            icon: "success",
            title: "Telecaller Assigned",
          });
          handleCloseModal();
          setUnemployed((prevState) =>
            prevState.map((item) =>
              item.id === selectedUnemployed.id
                ? { ...item, telecaller: telecaller, status: "Telecaller Assigned" } // Update telecaller and status
                : item
            )
          );
        }
      })
      .catch((err) => {
        console.log("ERROR", err);
      });
  }

  // Update searchTerm and reset pagination to first page
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0); // Reset to page 0 on search term change
  };

  return (
    <>
      <Navbar />
      <center>
        <h3 style={{ fontSize: "20px", position: "relative", top: "10px" }}>
          Suggestion and Counselling
        </h3>
      </center>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />
      </div>
      <div className="table-container">
        <table className="responsive-table" id="productstable">
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Candidate Name</th>
              <th>Contact</th>
              <th>Email</th>
              <th>Parent Details</th>
              <th>Type of Problem</th>
              <th>Problem Statement</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((i, index) => (
                <tr key={i.id}>
                  <td>{index + 1}</td>
                  <td>{i.Candidate_Name}</td>
                  <td>{i.Contact}</td>
                  <td>{i.Email}</td>
                  <td>{i.Parent_Details}</td>
                  <td>{i.Typeof_problem}</td>
                  <td>{i.Problem_statement}</td>
                  <td>{i.status ? i.status : "Not Assigned"}</td>
                  <td>
  <button
    type="button"
    style={{
      width: "80px",
      backgroundColor: "gainsboro",
      color: i.status !== "Not Assigned" ? "gray" : "black", // Change text color to gray if assigned
      borderRadius: "5px",
    }}
    onClick={() => handleOpenModal(i)}
    disabled={i.status !== "Not Assigned"} // Disable the button if the status is "Telecaller Assigned"
  >
    {i.status !== "Not Assigned" ? "Assigned" : "Assign" } {/* Show "Assigned" if already assigned */}
  </button>
</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">No unemployed candidates found</td>
              </tr>
            )}
          </tbody>
        </table>

        {filteredData.length > itemsPerPage && (
          <ReactPaginate
            previousLabel={"← Previous"}
            nextLabel={"Next →"}
            breakLabel={"..."}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
          />
        )}
      </div>

      {selectedUnemployed && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <h2>Assign Telecaller</h2>
            <p>Are you sure to assign {selectedUnemployed.Name}?</p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Telecaller</label>
                <select value={telecaller} onChange={(e) => setTelecaller(e.target.value)}>
                  <option>--Select--</option>
                  {telecallers.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.Employee_Name}
                    </option>
                  ))}
                </select>
              </div>
              <center>
                <button
                  type="submit"
                  style={{
                    width: "100px",
                    backgroundColor: "gainsboro",
                    borderRadius: "5px",
                  }}
                >
                  Assign
                </button>
              </center>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default ManagerSuggestion;